import actionTypes from "../../common/V2/actionTypes";
import { DATABASE_STATUTES } from "../../common/V2/constants";

const productReducer = (state, action) => {
  switch (action.type) {
    case actionTypes.FETCH_PRODUCTS:
      return {
        ...state,
        loading: true,
        error: null,
        statuses: {
          ...state.statuses,
          loadProducts: DATABASE_STATUTES.LOADING,
        },
      };

    case actionTypes.FETCH_PRODUCTS_SUCCESS: {
      return {
        ...state,
        products: action.payload.products || [],
        pagination: action.payload.pagination || {},
        statuses: {
          ...state.statuses,
          loadProducts: DATABASE_STATUTES.LOADED,
        },
        loading: false,
      };
    }

    case actionTypes.FETCH_PRODUCTS_FAILURE:
      return {
        ...state,
        error: action.payload,
        statuses: {
          ...state.statuses,
          loadProducts: DATABASE_STATUTES.LOADED_ERROR,
        },
      };

    // search
    case actionTypes.CLEAR_SEARCH:
      return {
        ...state,
        filtered: {
          data: [],
          hasNextPage: false,
          count: 0,
          entries: {},
        },
      };

    // filters
    case actionTypes.SAVE_PRODUCT_FILTERS:
      return {
        ...state,
        filters: action.payload,
      };

    // delete product
    case actionTypes.DELETE_PRODUCT:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case actionTypes.DELETE_PRODUCT_SUCCESS:
      return {
        ...state,
        products: state.products.filter((product) => product.id !== action.payload.productId),
        loading: false,
        error: null,
      };

    case actionTypes.DELETE_PRODUCT_FAILURE:
      return {
        ...state,
        error: action.payload,
        loading: false,
      };

    // update variant customer experience
    case actionTypes.UPDATE_VARIANT_CUSTOMER_EXPERIENCE_SUCCESS:
      return {
        ...state,
        products: state.products.map((product) => {
          if (product.id === action.payload.productId) {
            return {
              ...product,
              variants: product.variants.map((variant) => {
                if (variant.id === action.payload.variantId) {
                  return {
                    ...variant,
                    variantCustomerExperiences: variant.variantCustomerExperiences.map((vce) => {
                      // Replace the VCE that matches the returned VCE's ID (handle type conversion)
                      if (vce.id === action.payload.variantCustomerExperience.id) {
                        console.log("Updating VCE:", vce, "with:", action.payload.variantCustomerExperience);
                        // Use the updated VCE data from API response - it should contain the complete customerExperience object
                        return action.payload.variantCustomerExperience;
                      }
                      return vce;
                    }),
                  };
                }
                return variant;
              }),
            };
          }
          return product;
        }),
        error: null,
      };

    case actionTypes.UPDATE_VARIANT_CUSTOMER_EXPERIENCE_FAILURE:
      return {
        ...state,
        error: action.payload,
      };

    case actionTypes.START_OPERATION:
      return {
        ...state,
        operationState: {
          isProcessing: true,
          progress: 0,
          type: action.payload.type,
          message: action.payload.message || "",
        },
      };

    case actionTypes.UPDATE_OPERATION_PROGRESS:
      return {
        ...state,
        operationState: {
          ...state.operationState,
          progress: action.payload.progress,
        },
      };

    case actionTypes.COMPLETE_OPERATION:
      return {
        ...state,
        operationState: {
          isProcessing: false,
          progress: 0,
          type: null,
          message: "",
        },
      };

    // CSV uploads
    case actionTypes.FETCH_CSV_UPLOADS:
      return {
        ...state,
        statuses: {
          ...state.statuses,
          loadCsvUploads: DATABASE_STATUTES.LOADING,
        },
      };

    case actionTypes.FETCH_CSV_UPLOADS_SUCCESS:
      return {
        ...state,
        csvUploads: action.payload.uploads || [],
        csvUploadsPagination: action.payload.pagination || {},
        statuses: {
          ...state.statuses,
          loadCsvUploads: DATABASE_STATUTES.LOADED,
        },
      };

    case actionTypes.FETCH_CSV_UPLOADS_FAILURE:
      return {
        ...state,
        error: action.payload,
        statuses: {
          ...state.statuses,
          loadCsvUploads: DATABASE_STATUTES.LOADED_ERROR,
        },
      };

    case actionTypes.UPLOAD_CSV:
      return {
        ...state,
        statuses: {
          ...state.statuses,
          uploadCsv: DATABASE_STATUTES.IN_PROGRESS,
        },
      };

    case actionTypes.UPLOAD_CSV_SUCCESS:
      return {
        ...state,
        csvUploads: [action.payload, ...state.csvUploads],
        statuses: {
          ...state.statuses,
          uploadCsv: DATABASE_STATUTES.LOADED,
        },
      };

    case actionTypes.UPLOAD_CSV_FAILURE:
      return {
        ...state,
        error: action.payload,
        statuses: {
          ...state.statuses,
          uploadCsv: DATABASE_STATUTES.LOADED_ERROR,
        },
      };

    default:
      return state;
  }
};

export default productReducer;
